import { useTheme } from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import ObjectTypeIcons, { DEFAULT_ICON } from 'automation-ui-references/object-types/ObjectTypeIcons';
import DataSourceSkeleton from 'automation-ui-formula-editor/fetch-object-panel/components/DataSourceSkeleton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataSource = ({
  dataSourceToView,
  onRemove,
  onEdit
}) => {
  const trellisTheme = useTheme();
  const {
    data: dataSource,
    loading: queryLoading,
    error
  } = useGetDataSource(dataSourceToView);
  const {
    dataSourceDefinition
  } = dataSource || {};
  if (queryLoading) {
    return /*#__PURE__*/_jsx(DataSourceSkeleton, {});
  }
  if (!queryLoading && error) {
    return /*#__PURE__*/_jsx(Text, {
      paddingInlineStart: "400",
      color: "icon-core-subtle",
      children: /*#__PURE__*/_jsx("i", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.error.data-source-errored"
        })
      })
    });
  }
  const {
    label,
    metadata
  } = dataSourceDefinition;

  // calculate icon in precedence: association toObjectTypeId > metadata objectType > default icon
  const toObjectTypeId = metadata && 'associationDefinition' in metadata && metadata.associationDefinition.toObjectTypeId;
  const iconObjectTypeId = toObjectTypeId || metadata && 'objectTypeId' in metadata && metadata.objectTypeId;
  const icon = ObjectTypeIcons[iconObjectTypeId] || DEFAULT_ICON;
  return /*#__PURE__*/_jsx(UITile, {
    compact: true,
    children: /*#__PURE__*/_jsx(UITileSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "300",
        children: [/*#__PURE__*/_jsx(Box, {
          shrink: "0",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: icon,
            size: "xs",
            color: trellisTheme.color['icon-tertiary-default']
          })
        }), /*#__PURE__*/_jsx(Box, {
          grow: "1",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h7",
            role: "dataSourceTitle",
            children: label
          })
        }), /*#__PURE__*/_jsxs(Box, {
          shrink: "0",
          children: [onEdit && /*#__PURE__*/_jsx(UIIconButton, {
            onClick: () => onEdit(dataSourceDefinition),
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "edit"
            })
          }), onRemove && /*#__PURE__*/_jsx(UIIconButton, {
            onClick: () => onRemove === null || onRemove === void 0 ? void 0 : onRemove(dataSource),
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "delete"
            })
          })]
        })]
      })
    })
  });
};
export default DataSource;